<flex-row-start-center class="pc-warning-banner_container">
  <app-icon name="warning" color="#202020" class="pc-warning-banner_no-seats_icon"></app-icon>
  <div>
    {{ text }}
  </div>
</flex-row-start-center>
